import { ComponentItem } from "./component.item";
import customerJson from "../assets/config/customer.json";

var components = new Array<ComponentItem>();

for (let i = 0; i < customerJson.component.length; i++) {
	// Do not display inactive component that are not explicitly defined to be displayed
	if(customerJson.component[i].active || customerJson.component[i].displayInactive) {
		components.push(new ComponentItem(i+1, customerJson.component[i].fullName, customerJson.component[i].shortName, customerJson.component[i].routeName, customerJson.component[i].icon, customerJson.component[i].color, customerJson.component[i].selected, customerJson.component[i].active, customerJson.component[i].display, customerJson.component[i].description, customerJson.component[i].availableAdmin, customerJson.component[i].availableStdUser, customerJson.component[i].availableReadUser));
	}
}

export const Environment = {
  production: false,
  // List components
  components
};